/* OVERAALL V8.3: unobtrusive enhancements without replacing Shopify product form. */
(()=>{'use strict';
 const $=(s,r=document)=>r.querySelector(s);
 const productForm=$('#ov62-product-form');
 if(!productForm)return;
 const mainAdd=$('[data-ov2-add]',productForm);
 const sticky=$('[data-ov83-sticky]');
 const stickyCta=$('[data-ov83-sticky-cta]',sticky||document);
 const stickyPrice=$('[data-ov83-sticky-price]',sticky||document);
 const primaryPrice=$('[data-ov2-price]');
 const restockOpen=$('[data-ov83-restock-open]',productForm);
 const restockDialog=$('[data-ov83-restock-dialog]');
 const restockClose=$('[data-ov83-restock-close]',restockDialog||document);
 const restockVariant=$('[data-ov83-restock-variant]',restockDialog||document);
 const restockBody=$('[data-ov83-restock-body]',restockDialog||document);
 const select=$('[data-ov62-variant-select]',productForm);
 const productTitle=$('.ov31-prod-details h1')?.textContent?.trim()||'OVERAALL product';
 const originalVariant=productForm.querySelector('[name=id]')?.value||'';
 const currentVariant=()=>select?.value||originalVariant;
 const currentLabel=()=>select?.selectedOptions[0]?.textContent?.trim()||'Default';
 const unavailable=()=>mainAdd?.disabled&&!/ADDING/i.test(mainAdd.textContent||'');
 const isBusy=()=>/ADDING/i.test(mainAdd?.textContent||'');
 function sync(){
  const soldOut=unavailable();
  const label=currentLabel();
  if(restockOpen){restockOpen.hidden=!soldOut;restockOpen.setAttribute('aria-hidden',String(!soldOut));}
  if(restockVariant)restockVariant.textContent=productTitle+' / '+label;
  if(restockBody)restockBody.value='RESTOCK REQUEST\nProduct: '+productTitle+'\nVariant: '+label+'\nVariant ID: '+currentVariant()+'\nProduct URL: '+location.origin+location.pathname;
  if(stickyCta){stickyCta.textContent=isBusy()?'ADDING…':soldOut?'REQUEST NOTICE':'ADD TO BAG';stickyCta.disabled=isBusy();}
  if(stickyPrice&&primaryPrice)stickyPrice.textContent=primaryPrice.textContent;
 }
 // Keep sticky CTA hidden until the native add button has been scrolled past.
 function syncSticky(){
  if(!sticky||!mainAdd)return;
  const rect=mainAdd.getBoundingClientRect();
  const mobile=window.matchMedia('(max-width:750px)').matches;
  const passed=rect.bottom<0;
  const modal=Boolean(restockDialog?.open||$('[data-ov62-size-dialog]')?.open||$('[data-ov62-cart-drawer]')?.classList.contains('is-open'));
  // Give the collection link and footer the full viewport when reached.
  const backLink=$('.ov31-prod-details .ov2-back-link')||$('.ov2-back-link');
  const footer=$('.ov2-footer');
  const clearance=Math.max(sticky.offsetHeight,80)+24;
  const nearBottom=[backLink,footer].some(el=>{if(!el)return false;const r=el.getBoundingClientRect();return r.bottom>0&&r.top<window.innerHeight+clearance;});
  const visible=mobile&&passed&&!modal&&!nearBottom;
  sticky.inert=!visible;
  sticky.classList.toggle('is-visible',visible);
  sticky.setAttribute('aria-hidden',String(!visible));
  document.body.classList.toggle('ov83-sticky-visible',visible);
 }
 const openRestock=()=>{sync();if(restockDialog?.showModal)restockDialog.showModal();else restockDialog?.setAttribute('open','');syncSticky();};
 restockOpen?.addEventListener('click',openRestock);
 restockClose?.addEventListener('click',()=>{restockDialog?.close?.();syncSticky();});
 restockDialog?.addEventListener('click',e=>{if(e.target===restockDialog){restockDialog.close();syncSticky();}});
 restockDialog?.addEventListener('close',syncSticky);
 stickyCta?.addEventListener('click',()=>{
  sync();
  if(unavailable()){openRestock();return;}
  if(!mainAdd||isBusy())return;
  // One request only: the same Shopify form and Ajax-cart handler already used by the primary button.
  if(productForm.requestSubmit)productForm.requestSubmit(mainAdd);
  else mainAdd.click();
 });
 // Existing V6.2 script updates the button, price and select synchronously on option clicks.
 productForm.addEventListener('click',e=>{if(e.target.closest('[data-ov62-option-button]'))queueMicrotask(sync);});
 select?.addEventListener('change',sync);
 if(mainAdd&&window.MutationObserver){new MutationObserver(sync).observe(mainAdd,{attributes:true,attributeFilter:['disabled'],childList:true,characterData:true,subtree:true});}
 if(primaryPrice&&window.MutationObserver){new MutationObserver(sync).observe(primaryPrice,{childList:true,characterData:true,subtree:true});}
 window.addEventListener('scroll',syncSticky,{passive:true});
 window.addEventListener('resize',syncSticky,{passive:true});
 sync();syncSticky();
 // Shopify native recommendation API: complementary first, related as an honest fallback.
 const shell=$('[data-ov83-recommendations]');
 if(shell&&window.fetch){
  const load=async(url)=>{
   if(!url)return false;
   const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}});
   if(!response.ok)throw new Error('Recommendations unavailable');
   const html=await response.text();
   const doc=new DOMParser().parseFromString(html,'text/html');
   const contents=doc.querySelector('[data-ov83-rec-results]');
   if(!contents||!contents.querySelector('.ov83-recommendation'))return false;
   shell.replaceChildren(document.importNode(contents,true));
   return true;
  };
  const fetchRecommendations=async()=>{
   try{if(await load(shell.dataset.primaryUrl))return;}catch(_){}
   try{await load(shell.dataset.fallbackUrl);}catch(_){}
  };
  if(window.IntersectionObserver){
   const io=new IntersectionObserver((entries)=>{if(entries[0].isIntersecting){io.disconnect();fetchRecommendations();}},{rootMargin:'280px'});
   io.observe(shell);
  }else fetchRecommendations();
 }
 if(restockDialog?.querySelector('[data-ov83-restock-result]')){openRestock();}
})();

